'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CogAlternate;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function CogAlternate(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#000' : _ref$color;

  return _react2.default.createElement(
    'svg',
    { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-cog-alternate ' + className, width: width, height: height, viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fill: color, d: 'M16 9.501v-3.003l-2.293-0.382c-0.093-0.283-0.207-0.557-0.339-0.82l1.351-1.891-2.123-2.123-1.888 1.349c-0.264-0.134-0.54-0.248-0.825-0.342l-0.381-2.288h-3.003l-0.381 2.288c-0.285 0.094-0.56 0.209-0.824 0.342l-1.888-1.349-2.123 2.123 1.351 1.891c-0.132 0.263-0.246 0.537-0.339 0.82l-2.293 0.382v3.003l2.299 0.383c0.093 0.281 0.206 0.552 0.338 0.813l-1.355 1.898 2.123 2.123 1.901-1.358c0.259 0.13 0.53 0.243 0.809 0.335l0.384 2.304h3.003l0.384-2.304c0.279-0.092 0.549-0.204 0.809-0.335l1.901 1.358 2.123-2.123-1.355-1.898c0.132-0.261 0.245-0.532 0.338-0.813l2.299-0.383zM8 10c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2z' })
  );
}

CogAlternate.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/CogAlternate/CogAlternate.js
// module id = 198
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16